import React, {FC} from 'react'
import { LKDate } from 'loankeeper-common/helpers/Date'

import { colors } from 'shared'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
import { ScheduleData } from 'src/features/LoanDetails/types.LoanDetails'

const config = {
  gridIdentity: {
    formName: 'frm_loan_view',
    objectName: 'grd_schedule',
  },

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,

  columnConfigs: {
    OperDate: {
      valueFormatter: ({ value }) => LKDate.from(value).toString(),
    },

    Disburse: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    ProcFee: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    Principal: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    Interest: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    TotalCover: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    OSBalance: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    OtherExpenses: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    StatusRepaid: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },
  },

  getRowStyle: ({
    node: {
      data: { StatusDue, StatusRepaid },
    },
  }) => {
    switch (StatusDue) {
      case 1:
        return {
          backgroundColor: colors.yellow,
        }

      case 2: {
        if (StatusRepaid > 0) {
          return {
            backgroundColor: colors.red,
          }
        }

        return {
          backgroundColor: colors.grey,
        }
      }

      default:
        return {}
    }
  },

  getContextMenuItems: () => ['excelExport'],
}

const CurrentGraphic:FC<{
  instanceName: string,
  data: ScheduleData[]
}> = ({ instanceName, data }) => <LKGrid instanceName={instanceName} rowData={data} {...config} />


CurrentGraphic.defaultProps = {
  data: [],
}

export default React.memo(CurrentGraphic)
